// extracted by mini-css-extract-plugin
export var border = "_1l-8";
export var brand = "_1l-t";
export var button = "_1l-l";
export var center = "_1l-a";
export var centered = "_1l-6";
export var closeButton = "_1l-c";
export var disabledWrapper = "_1l-m";
export var error = "_1l-p";
export var extraLarge = "_1l-4";
export var extraSmall = "_1l-1";
export var fill = "_1l-i";
export var footer = "_1l-h";
export var footerAction = "_1l-j";
export var footerButtons = "_1l-k";
export var header = "_1l-7";
export var headerWithClose = "_1l-d";
export var icon = "_1l-o";
export var info = "_1l-s";
export var inline = "_1l-9";
export var large = "_1l-3";
export var main = "_1l-e";
export var modal = "_1l-0";
export var nearFull = "_1l-5";
export var neutral = "_1l-u";
export var noPadding = "_1l-g";
export var none = "_1l-v";
export var scrollable = "_1l-f";
export var small = "_1l-2";
export var success = "_1l-r";
export var tight = "_1l-n";
export var titleIcon = "_1l-b";
export var warn = "_1l-q";